import { useTranslation } from 'react-i18next';
import { RhfImageField, type RhfImageFieldProps } from './shared/RhfImageField';

export type AccountProofImageFieldProps = Omit<RhfImageFieldProps, 'label'> & {
  label?: string;
};

/**
 * `AccountProofImageField` — RHF-bound document upload for the
 * proof of bank account ownership.
 *
 * The backend currently stores this on `Bank.accountImage` (the
 * existing `Bank` schema slot for account-ownership scans). We
 * keep accepting PDFs in addition to images because most banks
 * issue an account statement / IBAN certificate as a PDF.
 */
export function AccountProofImageField(props: AccountProofImageFieldProps) {
  const { t } = useTranslation('m-organization');
  return (
    <RhfImageField
      {...props}
      label={props.label ?? t('form.account_picture.title')}
      uploadLabel={props.uploadLabel ?? t('form.account_picture.title')}
    />
  );
}
